import React from 'react';
import { Tooltip, IconButton, Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Hover (desktop) / tap (mobile) help for form labels.
 * @param {{ title: string, body: string, size?: 'small' | 'medium' }} props
 */
export default function InfoTooltip({ title, body, size = 'small' }) {
  const content = (
    <Box sx={{ maxWidth: 280, p: 0.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        {title}
      </Typography>
      <Typography variant="body2">{body}</Typography>
    </Box>
  );

  return (
    <Tooltip title={content} arrow placement="top" enterTouchDelay={0}>
      <IconButton size={size} sx={{ p: 0.25, ml: 0.5, verticalAlign: 'middle' }} aria-label={title}>
        <InfoOutlinedIcon fontSize={size} color="action" />
      </IconButton>
    </Tooltip>
  );
}

export function LabelWithInfo({ label, title, body }) {
  return (
    <Box component="span" display="inline-flex" alignItems="center">
      {label}
      <InfoTooltip title={title} body={body} />
    </Box>
  );
}
